import { Details, Table, TableCell, TableRow } from '@digdir/designsystemet-react';

import styled from '../../../../../styled';

interface IsHiddenProps {
  $isHidden?: boolean;
}

export const StyledTableRow = styled(TableRow) <IsHiddenProps>`
  ${({ $isHidden }) =>
    $isHidden &&
    `
    background-color: pink;

  `}
`;

export const StyledDetails = styled(Details)`
  min-width: 740px;
`;

export const HeaderTableRow = styled(Table.Row)`
  background-color: var(--ds-color-surface-tinted);
  font-weight: bold;
`;

export const BorderRightHeaderCell = styled(Table.HeaderCell)`
  border-right: 1px solid var(--ds-color-border-subtle);
`;

export const BorderRightTableCell = styled(TableCell)`
  border-right: 1px solid var(--ds-color-border-subtle);
`;

export const CalculatedValueTableCell = styled(TableCell)`
  width: 165px;
  border-right: 1px solid var(--ds-color-border-subtle);
  text-align: right;
`;

export const ExpertValueTableCell = styled(TableCell)`
  width: 189px;
`;
